import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService{

  private $isLoading = new BehaviorSubject<boolean>(false);

  public setIsLoading(isLoading: boolean) {
    setTimeout(() => this.$isLoading.next(isLoading)); // avoid expression changed angular exception
  }

  public observeIsLoading() {
    return this.$isLoading.asObservable();
  }

  public async run<T = void>(task: () => Promise<T>) {
    this.setIsLoading(true);
    try {
      return await task();
    } finally {
      this.setIsLoading(false);
    }
  }
}
